import type ChargeValidity from "entities/chargeValidity";
import type EnumService from "services/enumService";
import type PriceListService from "services/priceListService";
import { emptyValue } from "./emptyValue";
import { translateEnum } from "./localizations";

function nonEmpty(value?: string) {
  return value ? value : undefined;
}

export function chargeValidityLabel(validFor?: ChargeValidity) {
  if (!validFor) {
    return undefined;
  }

  return nonEmpty(translateEnum("chargeValidity", validFor));
}

export function translateChargeTypeByPriceListItem(
  priceListService: PriceListService,
  enumService: EnumService,
  priceListItemId?: string
) {
  if (!priceListItemId) {
    return emptyValue;
  }

  const chargeTypeId = priceListService.priceListItemById(priceListItemId)?.chargeTypeId;
  if (!chargeTypeId) {
    return emptyValue;
  }

  const chargeType = enumService.value("charge_types", chargeTypeId);
  if (!chargeType) {
    return emptyValue;
  }

  return chargeValidityLabel(chargeType.validFor) ?? nonEmpty(chargeType.description) ?? emptyValue;
}
